/**
 * LLMContent Component
 * 
 * A React component for safely rendering LLM (Large Language Model) generated content
 * as formatted markdown. This component handles AI-generated text responses and displays
 * them with proper markdown formatting, including tables, links, lists, and other
 * GitHub Flavored Markdown features.
 * 
 * Features:
 * - Markdown rendering with GitHub Flavored Markdown (GFM) support
 * - HTML sanitization for security (prevents XSS attacks)
 * - External links open in new tabs with security attributes
 * - Responsive image rendering with max-width constraints
 * 
 * @param {Object} props
 * @param {string} props.text - The markdown text to render (typically from an LLM response)
 */
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";
import { logEvent } from "../analytics";

const LLMContent = ({ text }) => {
  const safeText = typeof text === "string" ? text : "";
  return (
    <div className="markdown-body" style={{ lineHeight: 1.6 }}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSanitize]}
        components={{
          a: ({ node, ...props }) => (
            <a 
              {...props} 
              target="_blank" 
              rel="noopener noreferrer" 
              onClick={() => logEvent("chat_link_click", { href: props.href })}
            >
              {props.children}
            </a>
          ),
          img: ({ node, ...props }) => (
            <img 
              {...props} 
              alt={props.alt || ""} 
              style={{ maxWidth: "100%", height: "auto" }} 
            />
          )
        }}
      >
        {safeText}
      </ReactMarkdown>
    </div>
  );
};

export default LLMContent;


